import { ReactNode } from 'react'

import { Id } from '../types'

type BodyRowProps<TCol extends { id: Id }, TRow extends { id: Id }> = {
    cols: TCol[]

    row: TRow
    rowClassName?: (row: TRow) => string

    children: (column: TCol) => ReactNode
    cellClassName?: (row: TRow, col: TCol) => string
    actionButton?: (row: TRow, col: TCol) => ReactNode
    gridTemplateColumns: string
}

export const BodyRow = <TCol extends { id: Id }, TRow extends { id: Id }>({
    cols,
    row,
    children,
    rowClassName,
    gridTemplateColumns,
}: BodyRowProps<TCol, TRow>) => (
    <tr id={`row-${row.id}`} className={`group grid border-b last:border-b-0 ${rowClassName?.(row)}`} style={{ gridTemplateColumns }} data-test="body-row">
        {cols.map(col => children(col))}
    </tr>
)
